const removeIndex = (byIndex, removedIndex) =>
    Object.entries(byIndex).reduce((next, [key, value]) => {
        const index = Number(key);
        if (index === removedIndex) return next;
        return { ...next, [index > removedIndex ? index - 1 : index]: value };
    }, {});

export default removeIndex;
